import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { Suggestion } from '../../utilities/VehicleSuggestion/Suggestion';
import { Vehicle } from '../../DataStructures/Vehicle/Vehicle';
import { VehicleType } from '../../DataStructures/Vehicle/VehicleType';
@Injectable()
export class VehicleService {

  constructor(private http: Http) { }

  createVehicleType(name: string, capacity: number): Promise<String> {

    let body = {
      "name": name,
      "capacity": capacity
    }

    return this.http.post(
      ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.VEHICLE_TYPE,
      JSON.stringify(body)
    ).toPromise().then(res => res.json())
  }

  getVehiclesByBatchId(id: string): Promise<string> {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_VEHICLES_BY_BATCH_ID + "/" + id;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getVehicleTypes(): Promise<any> {

    return this.http.get(ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.VEHICLE_TYPE).toPromise()
      .then(res => res.json())
  }

  async getNextVehicleIncrement(capacity) : Promise<VehicleType>{
    var response = await this.getVehicleTypes();
    var types : Array<VehicleType> = response.data;
    types = types.sort((a,b) => a.capacity - b.capacity);
    var currentType = types.find(t => t.capacity == capacity);
    var index = types.indexOf(currentType);
    return types[index+1];
  }

  getCompanyLocationVehicles(companyid, locationid): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_COMPANY_LOCATION_VEHICLES + "/" + companyid + "/" + locationid;
    return this.http.get(url).toPromise().then(res => res.json());
  }


  getVehicle(id = null): Promise<string> {

    var url = "";
    if (id) {
      url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.VEHICLE + "/" + id;
    } else {
      url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.VEHICLE;
    }
    return this.http.get(url)
      .toPromise().then(res => res.json());
  }

  getAvailableVehicles(companyid: number, locationid: number): Promise<string> {


    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_AVAILABLE_VEHICLES + "/" + companyid + "/" + locationid;
    return this.http.get(url).toPromise().then(res => res.json())
  }

  createVehicle(body): Promise<string> {


    let url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.VEHICLE;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json())
  }

  bulkCreateVehicles(vehicles: Array<Vehicle>) {

    let url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.BULK_CREATE_VEHICLE;
    return this.http.post(url, JSON.stringify(vehicles)).toPromise().then(res => res.json())
  }

  public createVehiclesFromSuggestions(suggestions: Array<Suggestion>): Promise<Array<Vehicle>> {
    return new Promise(async (resolve, reject) => {

      var error = null;
      var s = null;

      var vehiclesArray = [];
      var vehiclesToReurn : Array<Vehicle> = [];
      var id = this.guid();
      suggestions.forEach(s => {
        vehiclesArray.push({
          "vehicletypeid": s.vehicleReservation.vehicle.vehicletypeid,
          "make": s.vehicleReservation.vehicle.make,
          "model": s.vehicleReservation.vehicle.model,
          "year": s.vehicleReservation.vehicle.year,
          "available": s.vehicleReservation.vehicle.available,
          "litersperkilometer": null,
          "contracted": 1,
          "companyid": s.vehicleReservation.vehicle.companyid,
          "company_location_id": s.vehicleReservation.vehicle.company_location_id,
          "batchContractid": id,
          "runtimeid":s.vehicleReservation.vehicle.runtimeid
        });
      });

      /**
      * Don't commit the vehicles to the DB here, just generate them in memory
      * and save them later
      */
      this.bulkCreateVehicles(vehiclesArray).then(res => {
        if (res.status == true) {
          this.getVehiclesByBatchId(id).then((result:any) =>{
            if(result.status){
              var v : Array<Vehicle> = result.data;
              v.forEach(vehicle =>{
                vehiclesToReurn.push(new Vehicle(vehicle));
              });
              resolve(vehiclesToReurn);
            }else{
              reject(result.message);
            }
          }).catch(e =>{
            reject(e);
          })
        } else {
          reject(res.message);
        }

      }).catch(e => { reject(e) });
    });
  }

  public deleteVehicles(vehicles: Array<any>) {

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.DELETE_VEHICLES;
    return this.http.post(url, JSON.stringify(vehicles)).toPromise().then(res => res.json());
  }

  guid() {

    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

}
